module.exports = __webpack_public_path__ + "img/93966.fd34167b.svg";